<template>
    <div style="height: 100%;width: 98%;margin: auto;" v-show="isShow">
        <div class="news-box">
            <h2 ref="newsTitle" class="news-title" :style="{ fontSize: titleFontSize + 'px' }">{{ form.title }}</h2>
            <div style="display: flex;width: 100%;margin-bottom: 10px">
                <div style="width: 68%;color: #666666;font-size: 14px;">发布时间：{{ timestampToTime(form.releaseTime) }}</div>
                <div style="width: 32%;color: #666666;font-size: 14px;margin: auto;justify-content: flex-end;text-align: right;padding-right: 5px">
                    阅读人数：{{ form.readNum }}
                </div>
            </div>

            <div v-html="form.appContent">
            </div>
        </div>
    </div>
</template>

<script>
import { timestampToTime } from "@/utils/date";
import {shareBannerInfo,shareNewsInfo,readShare} from "@/api/admin/share"
export default {
    name: "newShare",
    components: {},
    data() {
        return {
            isShow:false,
            shareId:'', //分享参数
            type:'', //分享类型 0-新闻  1-banner
            form:{},  //数据
            titleFontSize:24, //标题字号，随容器宽度自适应缩小
            timestampToTime,
        };
    },
    created() {},
    mounted() {
        this.shareId = this.$route.query.id;
        this.type = this.$route.query.type;
        this.getShareInfo();
        window.addEventListener('resize', this.fitTitleFont);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.fitTitleFont);
    },
    computed: {},
    methods: {
        //根据容器宽度自动缩小标题字号，保证标题完整显示为一行
        fitTitleFont() {
            this.$nextTick(() => {
                const el = this.$refs.newsTitle;
                if (!el) return;
                const max = 24;
                const min = 10;
                this.titleFontSize = max;
                this.$nextTick(() => {
                    const ratio = el.clientWidth / el.scrollWidth;
                    if (ratio < 1) {
                        this.titleFontSize = Math.max(min, Math.floor(max * ratio));
                    }
                });
            });
        },
        getShareInfo() {
            console.log("id=="+this.shareId)
            console.log("type=="+this.type)
            if (this.shareId===''||this.shareId===undefined||this.shareId===null){
                this.$message.error("分享信息有误")
                return;
            }
            if (this.type==='0'){
                shareNewsInfo({id:this.shareId}).then(res => {
                    if (res.data.code===1){
                        this.form = res.data.data;
                        this.isShow = true;
                        this.fitTitleFont();
                        readShare({id:this.shareId,type:this.type}).then(res=>{})
                    }else {
                        this.$message.error(res.data.msg);
                    }
                })
            }
            if (this.type==='1'){
                shareBannerInfo({id:this.shareId}).then(res => {
                    if (res.data.code===1){
                        this.form = res.data.data;
                        this.isShow = true;
                        this.fitTitleFont();
                        readShare({id:this.shareId,type:this.type}).then(res=>{})
                    }else {
                        this.$message.error(res.data.msg);
                    }
                })
            }

        }
    },

}

</script>

<style scoped>
.news-title{
    text-align: center;
    white-space: nowrap;
}

.news-box{
    height:100vh;
    overflow: auto;
    scrollbar-width: none;
}

.news-box::-webkit-scrollbar {
    display: none;
}
</style>